import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiInterfaceModel } from '../../models/resources/api-interface.model';
import { AResourceService } from './a-resource.service';

@Injectable({
  providedIn: 'root',
})
export class ApiInterfaceService extends AResourceService<ApiInterfaceModel> {
  constructor() {
    super('/api-interfaces', true);
  }

  /**
   * Partner/Customers von Odoo für diese API-Schnittstelle abrufen und fehlende bei uns anlegen.
   */
  syncCustomers(apiInterfaceId: number): Observable<{ imported: number }> {
    return this.http.post<{ imported: number }>(
      environment.apiUrl + `/api-interfaces/${apiInterfaceId}/sync-customers`,
      {}
    );
  }
}
